import { Product } from '@/types/product';
import { ArrowRight } from 'lucide-react';
import { ProductCard } from './ProductCard';
import { Button } from './ui/button';

interface ProductCategoryRowProps {
  title: string;
  products: Product[];
  onViewAll?: () => void;
  className?: string;
  limit?: number;
  totalCount?: number;
}

export function ProductCategoryRow({
  title,
  products,
  onViewAll,
  className = '',
  limit = 4,
  totalCount,
}: ProductCategoryRowProps) {
  if (products.length === 0) return null;

  const productsToShow = limit ? products.slice(0, limit) : products;
  const displayCount = totalCount !== undefined ? totalCount : products.length;

  return (
    <div className={`py-3 md:py-4 mb-10 ${className}`}>
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-base md:text-lg tracking-tight text-primary">
          {title}
        </h2>
        {displayCount > 4 && (
          <Button
            variant="ghost"
            onClick={onViewAll}
            className="text-primary hover:text-primary whitespace-nowrap text-xs"
          >
            View All ({displayCount}){' '}
            <ArrowRight className="ml-1.5 h-3 w-3" />
          </Button>
        )}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-5">
        {productsToShow
          .filter(product => product.price != null)
          .map(product => (
            <ProductCard
              key={product.id}
              {...product}
              tags={[product.category]}
            />
          ))}
      </div>
    </div>
  );
}
